import React from 'react';
import AtelierMap from './AtelierMap';

export default function FindUsSection() {
  return (
    <section className="px-[6vw] pb-[100px]">
      <div className="max-w-container-narrow mx-auto grid grid-cols-1 lg:grid-cols-[1fr_1.6fr] gap-10 items-start">
        <div>
          <div className="text-eyebrow uppercase tracking-wider text-gold font-medium mb-3">Τοποθεσία</div>
          <h2 className="font-serif text-warm-black mb-6">Πού θα μας βρείτε</h2>
          <p className="text-body text-warm-black mb-2">Ηρακλείτου 80, Χαλάνδρι 15238</p>
          <p className="text-body mb-6">
            <a href="tel:+302118004132" className="text-gold hover:text-gold-dark underline underline-offset-2">211 800 4132</a>
          </p>
          <div className="text-eyebrow uppercase tracking-wider text-gold font-medium mb-2">Ωράριο</div>
          <ul className="text-body-s text-muted space-y-1">
            <li>Τρ / Πέ / Πα · 10:00–20:00</li>
            <li>Τε / Σα · 09:00–17:00</li>
            <li>Δε / Κυ · κλειστά</li>
          </ul>
        </div>
        <AtelierMap />
      </div>
    </section>
  );
}